
import { Button, Spin, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../context/userContext';
import { AuthService } from '../../services/AuthService';
import moment from 'moment';
import { Link, useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';

// Optional: Define your PropTypes if you are using them
// import PropTypes from 'prop-types';

const Promotions = (props) => {
    

const columns = [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
    },
    {
        title: "Promocioni",
        dataIndex: "title",
        key: "title"
    },
    {
        title: "Pershkrim",
        dataIndex: "description",
        key: "description"
    },
    {
        title: "Aktiv nga",
        dataIndex: "startDate",
        key: "startDate"
    },
   
    {
        title: "Aktiv deri",
        dataIndex: "endDate",
        key: "endDate"
    },
    {
        title: "Produkte",
        dataIndex: "products",
        key: "products"
    },
    

]

const navigate = useNavigate();

    const [promotions, setPromotions] = useState([]);
    const [loading, setLoading] = useState(false);

    const {user} = useContext(UserContext);

    
    const getPromotions =async () => {
        setLoading(true);
        let res = await AuthService.getPromotions({});
        console.log("get all orders", res);
        if (res && res.length > 0) {
            let formatted = res.map(el => {
                let upEl = { ...el };
                upEl.startDate = moment(upEl?.startDate).format("DD.MM.YYYY");
                upEl.endDate = moment(upEl?.endDate).format("DD.MM.YYYY");
                
                
                
                upEl.products = upEl.promotionItems.length
                return upEl;
            })
            setPromotions(formatted);
        }
        else{
            setPromotions([])
        }
        setLoading(false);
    }
    useEffect(() => {
       getPromotions();
    }, []);

    const handleRowClick = (record) => {
        // let obj = record.id;
        console.log("record", record);
        const { ...productWithoutPr } = record;

        console.log(productWithoutPr);

        navigate("/promotion", { state: { promotion: productWithoutPr } });
        // navigate("/orders/view", { state: { order: record } });
    }

    // Event handler example
    const handlePromotionClick = (id) => {
        console.log(`Promotion with id ${id} clicked`);
    };

    return (
        <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-2">
            <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Promocionet</Title>

        </div>
        <div className="d-flex justify-content-end align-items-center">
            <div className="d-flex justify-content-start">
            {(user?.details?.roleName == "Admin" || user?.details?.roleName == "Manager") && (
                            <Link to="/promotions/new">
                                <Button type="primary" icon={<PlusOutlined />}>Shto një të ri</Button>
                            </Link>
                        )}
            

            </div>
        </div>
        <Spin spinning={false} tip="Duke procesuar te dhenat..."><Table dataSource={promotions} size="small" columns={columns} style={{ marginTop: 20 }} onRow={(record) => ({
            onClick: () => {
                handleRowClick(record);
            },
        })} /></Spin>

    </div>
    );
};

// Optional: Define PropTypes if needed
// Promotions.propTypes = {
//   // Define your prop types here
// };

export default Promotions;
